import * as RadixSelect from "@radix-ui/react-select";
import Select from "react-select";
import styled, { css } from "styled-components";
import { Flex } from "../Flex";
import { StyledInput } from "../Input/styles";
import { blueScrollBarStyles } from "../helpers";
const ellipsis = css `
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
`;
export const ReactSelect = styled(Select) `
	width: 100%;
	outline: transparent;

	background-color: var(--surface-white);

	[class*="control"] {
		flex-wrap: nowrap;
		height: ${({ size }) => {
    if (size === "small")
        return "32px";
    if (size === "large")
        return "48px";
    return "40px";
}};

		padding: 0 16px;
		border: 1px solid
			${({ feedback }) => {
    if (feedback === "success")
        return "var(--semantic-success-base)";
    if (feedback === "warning")
        return "var(--semantic-warning-base)";
    if (feedback === "error")
        return "var(--semantic-error-base)";
    return "var(--border-primary)";
}};
		border-radius: 4px;

		color: var(--text-primary);
		cursor: pointer;
		transition: border 300ms ease-in-out;

		${({ isDisabled }) => isDisabled &&
    css `
				border-color: var(--border-disable);
				background-color: var(--surface-primary);
				cursor: not-allowed;
			`}

		&:hover, &:focus-within {
			border-color: var(--border-active);
		}

		[class*="indicatorSeparator"] {
			display: none;
		}

		[class*="placeholder"] {
			color: var(--text-disable);
			${ellipsis}
		}

		[class*="indicatorContainer"] svg {
			transition: all 300ms ease-in-out;
			${({ menuIsOpen }) => menuIsOpen && "rotate: 180deg;"}
			${({ isDisabled }) => isDisabled && "display: none;"}
		}
	}

	[class*="menu"] {
		margin: 0;
		margin-top: 8px;
		padding-right: 2px;

		background-color: var(--surface-white);
		border: 1px solid var(--border-primary);
		border-radius: 4px;
		box-shadow: 0px 3px 8px 0px #00000040; // validar com o Edu qual o token deveria ser usado aqui.

		z-index: 160;

		[role="listbox"] {
			padding: 4px;
			max-height: 230px;
			overflow-y: auto;
			overflow-x: hidden;

			${blueScrollBarStyles()}
		}
	}
`;
// ^ React-Select
// V Radix
export const ButtonUnSelectOption = styled.button `
	padding: 0;
	cursor: pointer;
`;
export const SelectTrigger = styled(StyledInput) `
	display: flex;
	align-items: center;
	position: relative;
	padding-right: 12px;
	user-select: none;

	&[data-placeholder] {
		span {
			${ellipsis}
		}
	}

	width: 100%;

	text-align: left;
	cursor: pointer;

	${({ isOpen }) => isOpen &&
    css `
			border-color: var(--border-active);
		`}

	${({ waiting }) => waiting &&
    css `
			cursor: wait !important;
			background-color: var(--surface-white) !important;
		`}

	${ButtonUnSelectOption} {
		display: none;
	}

	&:not([data-placeholder]) p {
		color: var(--text-primary) !important;
	}

	&[data-placeholder] {
		color: var(--text-disable);
	}

	&:focus {
		border-color: var(--border-primary);
	}

	span {
		&:first-child {
			flex: 1;
		}

		&:last-child {
			display: flex;
			align-items: center;
		}
	}

		${({ selectType }) => {
    return (selectType === 'boxless' &&
        css `
            background-color: transparent;
        `);
}}
`;
export const SelectValue = styled(RadixSelect.Value) `
	flex: 1;
`;
export const SelectContent = styled(RadixSelect.Content) `
	background-color: var(--surface-white);
	border: 1px solid var(--border-primary);
	width: var(--radix-select-trigger-width);
	box-shadow: 0px 3px 8px 0px #00000040; // validar com o Edu qual o token deveria ser usado aqui.
	border-radius: 4px;
	padding: 4px;

	max-height: 230px;
	overflow-y: auto;

	${({ selectType }) => {
    return (selectType === 'boxless' &&
        css `
            width: auto !important;
        `);
}}

`;
export const StyledSelectItem = styled(Flex) `
	cursor: pointer;
	padding: 8px;
	transition: background-color 300ms ease-in-out;
	background-color: var(--surface-white);
	border-radius: 4px;

	span[id*="radix"] {
		width: 100%;
	}

	&:focus {
		outline: transparent;
	}

	&:hover:not([data-disabled]:not([data-state="checked"])) {
		background-color: var(--surface-accent-light) !important;
	}

	&[data-disabled]:not([data-state="checked"]) {
		background-color: var(--surface-primary);
		cursor: not-allowed;
	}

	&[data-state="checked"] {
		background-color: var(--surface-white);
		cursor: default;

		span {
			color: var(--text-link);
		}
	}

	.label-field {
		width: 100%;
	}

	.hidden-in-options {
		display: none;
	}
`;
//# sourceMappingURL=styles.js.map